import React from "react";
import { Link } from "react-router-dom";
import { FaUserCircle, FaBars } from "react-icons/fa";
import { useAuth } from "../Context/AuthContext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ChangePasswordModal from "../Modals/ChangePasswordModal";

export default function Navbar({ sidebarCollapsed, setSidebarCollapsed }) {
  const { user, logout } = useAuth();
  const username = user?.username || "User";
  const email = user?.email || "user@example.com";
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const [showChangePassword, setShowChangePassword] = useState(false);

  // logout function
  const handelLogout = () => {
    logout();
    navigate("/");
    toast.success(" User Logged out ");
  };

  return (
    <nav
      className="top-navbar navbar navbar-expand-lg sticky-top"
      style={{ backgroundColor: "#556ee6" }}
    >
      <div className="container-fluid d-flex justify-content-between align-items-center">
        {/* Hamburger Menu Button */}
        <button
          className="btn btn-link text-white d-flex align-items-center hamburger-nav-btn"
          onClick={() => setSidebarCollapsed((s) => !s)}
          aria-label={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <FaBars
            size={20}
            className={`hamburger-icon ${sidebarCollapsed ? "rotated" : ""}`}
          />
        </button>

        {/* User Icon with hover tooltip */}
        <div className="dropdown">
          <button
            className="btn btn-link text-white d-flex align-items-center"
            onClick={() => setShowMenu((prev) => !prev)}
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title={email} // 👈 shows email on hover
          >
            <FaUserCircle size={28} />
          </button>

          {/* Dropdown Menu */}
          {showMenu && (
            <div className="dropdown-menu dropdown-menu-end show mt-2 shadow">
              <div className="px-3 py-2">
                <div className="fw-semibold">{username}</div>
                <div className="text-muted small">{email}</div>
              </div>
              <div className="dropdown-divider"></div>

              {/* ✅ Change Password Button */}
              <button
                className="dropdown-item"
                // onClick={() => navigate("/user/change-password")}
                onClick={() => setShowChangePassword(true)}
              >
                Change Password
              </button>
              <button
                className="dropdown-item text-danger"
                onClick={handelLogout}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
      {/* Change Password Modal */}
      <ChangePasswordModal
        show={showChangePassword}
        onClose={() => setShowChangePassword(false)}
        isSuperUser={true}
      />
    </nav>
  );
}
